import React, { useState, useEffect } from "react"
import {
    getMDHData,
    getMDHParticipantInfo,
    getMDHParticipantSurveyInfo,
    // saveSurveyResponseWithMDH
} from "../../../services/formService"
import CustomLoader from "../../common/Loader"
import CustomTooltip from '../../common/CustomTooltip'
import * as Icon from 'react-feather'
import {Markup} from "interweave"
import moment from "moment";

const MDHDataViewer = ({Widget_ID, Form_ID, PrimaryKey, Project_ID, updateFormMDH, saveSurveyResponseWithMDH}) => {
    const [loading, setLoading] = useState(true)
    const [title, setTitle] = useState('')
    const [widgetDescription, setWidgetDescription] = useState('')
    const [MDHAPIResult, setMDHAPIResult] = useState('')
    const [updateQuestionWidgetID, setUpdateQuestionWidgetID] = useState()
    const [type, setType] = useState('');
    const [fieldResults, setFieldResults] = useState([]);
    const [MDHAnswerTime, setMDHAnswerTime] = useState('')

    useEffect(() => {
        const preloadMDHData = async () => {
            const { data } = await getMDHData(Widget_ID);
            if (data.length !== 0) {
                setTitle(data[0].Title || '')
                setWidgetDescription(data[0].Description || '')
                setUpdateQuestionWidgetID(data[0].Update_Question_Widget_ID || 0)
                setType(data[0].Type);
                if (PrimaryKey && data[0].MDH_Project_ID) {
                    if (data[0].Type === 'Get Participant Info' || data[0].Type === 'Update Participant Info') {
                        // fetch result from MDH participant info for current participant
                        const {data: result} = await getMDHParticipantInfo(data[0].MDH_Project_ID, PrimaryKey, data[0].Participant_Info_Field)
                        if (typeof result === 'string' && result.includes('Error')) {
                            console.error(result);
                        } else {
                            const fields = data[0].Participant_Info_Field.split(',');
                            let fResults = [];
                            fields.map((field) => {
                                let value = '';
                                let fieldName = field;
                                if (field.includes('.')) {
                                    let splitField = field.split('.');
                                    fieldName = splitField[1];
                                    value = result[splitField[0]][fieldName];
                                } else {
                                    value = result[field]
                                }
                                const parsed_result = moment(value.toLocaleString()).format('YYYY-MM-DD')
                                if (parsed_result !== 'Invalid date') {
                                    value = parsed_result;
                                }
                                fResults.push({field, fieldName, value: value.trim()});
                            })
                            // console.log(fieldResults);
                            if (data[0].Type === 'Get Participant Info') {
                                setMDHAPIResult(fResults[0].value === '' ? 'No MDH Data' : fResults[0].value)
                            } else {
                                setFieldResults(fResults);

                                // update FormViewer with the mdh fields that have no data and need to be updated upon save
                                let fieldsToUpdate = fResults.filter(r => r.value === '').map(r => r.field);
                                if (fieldsToUpdate.length > 0) {
                                    updateFormMDH(Widget_ID, data[0].MDH_Project_ID, fieldsToUpdate, data[0].Update_Question_Widget_ID);
                                }
                            }
                        }
                    } else if (data[0].Type === 'Get Survey Info' || data[0].Type === 'Get Survey Answer Date') {
                        // fetch result from MDH survey answers for current participant
                        if (data[0].MDH_Survey_Name && data[0].MDH_Question_Step_Identifier) {
                            let { data: result } = await getMDHParticipantSurveyInfo(data[0].MDH_Project_ID, PrimaryKey, data[0].MDH_Survey_Name.replace(/ /g, "%20"), data[0].MDH_Question_Step_Identifier.replace(/ /g, "%20"))
                            if (typeof result === 'string' && result.includes('Error')) {
                                console.error(result)
                            } else {
                                result = result["data"]
                                // console.log(result)
                                if (result['surveyAnswers'].length > 0) {
                                    if (data[0].Type === 'Get Survey Answer Date') {
                                        let answer_date = result['surveyAnswers'][0]['date']
                                        setMDHAPIResult(answer_date)
                                        setMDHAnswerTime(new Date(answer_date).toLocaleString('en-ca', { timeZoneName: 'short' }))
                                    } else {
                                        setMDHAPIResult(result['surveyAnswers'][0]['answers'] ? result['surveyAnswers'][0]['answers'][0] : 'No MDH Data')
                                    }
                                } else {
                                    setMDHAPIResult('No MDH Data')
                                    setMDHAnswerTime('No MDH Data')
                                }
                            }
                        }
                    }
                } else {
                    console.error('Error: No primary key given or no MDH project ID specified')
                }
            }
        }
        preloadMDHData()
            .then(() => setLoading(false))
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        // MDHAPIResult can be either 'No MDH Data' or a value pulled from MDH
        if (MDHAPIResult !== '' && !MDHAPIResult.includes('No') && updateQuestionWidgetID > 0) {
            saveSurveyResponseWithMDH(MDHAPIResult, updateQuestionWidgetID, Project_ID, Form_ID, PrimaryKey)
        }
    }, [MDHAPIResult])

    if (loading) {
        return <CustomLoader loading={loading} />
    }

    return <div className='col'>
        <div id={Widget_ID} className={'card border-lg pointer'} style={{'borderColor': 'blue'}}>
            <div className="card-body">
                <div className="flex-grow-1">
                    <div className="small font-weight-bold text-primary mb-1">
                        {title}
                        {widgetDescription && (
                            <CustomTooltip title={widgetDescription} placement='right'
                                           className="text-muted pl-1 d-inline">
                                <Icon.Info size={20}/>
                            </CustomTooltip>
                        )}
                    </div>
                    {type === 'Update Participant Info' ? (
                        fieldResults.map((field, idx) => (
                            <p key={idx} style={{marginBottom: 0}}><b>{field.fieldName}: </b>
                                {field.value === '' ? ' No data. Will auto-update upon save' : field.value}</p>
                        ))
                    ) : (
                        <Markup tagName='h5' content={type === 'Get Survey Answer Date' ? MDHAnswerTime.toString() : MDHAPIResult.toString()}/>
                    )}
                </div>
            </div>
        </div>
    </div>
}

export default MDHDataViewer